import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

export const About = (props) => {
  const { className } = props;
  const id = props.id + "-tooltip";

  const tooltip = (
    <Tooltip id={id}>
      <div className='text-start'>{props.children}</div>
    </Tooltip>
  );

  return (
    <>
      <OverlayTrigger key={id} placement='top' overlay={tooltip}>
        <a href='javascript:void(0)'>
          <i className='bi bi-info-circle'></i>
        </a>
      </OverlayTrigger>
    </>
  );
};
